// @flow
import * as React from 'react';
import type {TerminalContext} from 'docs/types';
import {InlineCode} from 'docs/components/core/InlineCode/InlineCode';

type AddressRequirementsByCountry = $PropertyType<
  TerminalContext,
  'address_requirements_by_country',
>;

type LocationAddressRequirementsProps = {|
  addressRequirementsByCountry: AddressRequirementsByCountry,
  country: string,
|};

export const TerminalLocationAddressRequirementsPhrase = ({
  addressRequirementsByCountry,
  country,
}: LocationAddressRequirementsProps) => {
  if (
    !addressRequirementsByCountry ||
    !country ||
    !addressRequirementsByCountry[country]
  ) {
    return null;
  }

  const requirements = addressRequirementsByCountry[country];
  const requiredProperties = Object.keys(requirements).filter(
    (property) => requirements[property],
  );
  const numRequiredProperties = requiredProperties.length;

  if (numRequiredProperties < 1) {
    return null;
  } else if (numRequiredProperties === 1) {
    return <InlineCode content={requiredProperties[0]} />;
  } else if (numRequiredProperties === 2) {
    return (
      <span>
        <InlineCode content={requiredProperties[0]} />
        &nbsp;and&nbsp;
        <InlineCode content={requiredProperties[1]} />
      </span>
    );
  } else {
    return (
      <span>
        {requiredProperties.map((property, i) =>
          i < requiredProperties.length - 1 ? (
            <span key={property}>
              <InlineCode content={requiredProperties[i]} />
              ,&nbsp;
            </span>
          ) : (
            <span key={property}>
              and&nbsp;
              <InlineCode content={requiredProperties[i]} />
            </span>
          ),
        )}
      </span>
    );
  }
};
